(function ($) {
    $(function () {
        function planRoute(event, routePlannerElement) {
            event.preventDefault();

            // Turn-off
            if (
                routePlannerElement.attr('src') === 'assets/img/icons/icon-route-active.svg' &&
                window.routedGraveId === window.selectedGraveId
            ) {
                window.widget.toggleRouteLayer(window.selectedGraveId);
                routePlannerElement.attr('src', 'assets/img/icons/icon-route.svg');
                window.routedGraveId = null;
                return;
            }

            $.ajax({
                url: `${window.api}/route/${window.selectedGraveId}`,
                type: 'GET',
                async: false,
                headers: {
                    Authorization: 'Bearer ' + window.iFrameToken,
                },
                dataType: 'json',
                error: function(error) {
                    console.log(error);
                    return;
                },
                success: function(routeData) {
                    if (routeData) {
                        window.widget.toggleRouteLayer(window.selectedGraveId, routeData);
                        routePlannerElement.attr('src', 'assets/img/icons/icon-route-active.svg');
                        window.routedGraveId = window.selectedGraveId;
                    }
                },
            });
        }

        const aboutBox = $('.about-box');
        const marker = $('.js-mark-selection');
        const routePlanner = $('.js-get-route');

        marker.on('click', function() {
            window.widget.markSelected();

            if (
                marker.attr('src') === 'assets/img/icons/icon-location-marked.svg' &&
                window.markedGraveId === window.selectedGraveId
            ) {
                window.markedGraveId = null;
                marker.attr('src', 'assets/img/icons/icon-location.svg');
                return;
            }

            window.markedGraveId = window.selectedGraveId;
            marker.attr('src', 'assets/img/icons/icon-location-marked.svg');
        });

        $('.js-close-about').on('click', function() {
            aboutBox.removeClass('about-box-visible');

            if (!$('.js-urnwall-modal').hasClass('visible-print')) {
                $('.js-load-one-urnwall-data').removeClass('urn--active');
            }

            if ($(window).width() < 545) {
                aboutBox.css('height', '420px');
            }
        });

        routePlanner.on('click', function(e) {
            planRoute(e, routePlanner);
        });
    });
})(jQuery);
